import { TransactionBroadcastFailedError } from '../../../errors/TransactionBroadcastFailedError';
import { TransactionRequiredError } from '../../../errors/TransactionRequiredError';
import { MEMPOOL_API_URL } from '../../constants';

/**
 * Sends a raw Bitcoin transaction to the mempool
 *
 * @param rawTransaction - The raw transaction in hex format
 * @returns The transaction ID
 * @throws {TransactionRequiredError} if no transaction is specified
 * @throws {TransactionBroadcastFailedError} if broadcasting fails
 */
export const broadcastTransaction = async (
  rawTransaction: string
): Promise<string> => {
  if (!rawTransaction) {
    throw new TransactionRequiredError();
  }

  const response = await fetch(`${MEMPOOL_API_URL}/tx`, {
    body: rawTransaction,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
  });

  if (!response.ok) {
    throw new TransactionBroadcastFailedError({ response });
  }

  return response.text();
};
